import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import * as actions from '../../actions/index';
//image
import vuepay_large_logo from '../../assets/images/vuepaylogonav@5x.png';
import loading_white from '../../assets/gif/loading_white.gif';
//internal js
import CryptoJS from 'crypto-js';
import { Link } from 'react-router-dom';
import { isValidPassword, vuepayAlert, vuePayLog } from "../../util/utility";
import IntlTelInput from 'react-intl-tel-input';
import { checkIfTwoFactorAuth, renderField } from "../../util/account_management";
import { redirectIfSessionExist } from "../../util/storage";
import strings from "../../util/strings";
import { get as _get } from "lodash";


class VerfiyMobileNumber extends Component {

    required = value => (value ? undefined : 'Required');

    constructor(props) {
        super(props);
        this.state = {
            componentMounted: false,
            country_code: '+44',
            mobile_number: '',
            mobile_number_error: false,
            mobile_number_valid: false,
            count: 0,
            resent_otp: false
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.mobileNumberChange = this.mobileNumberChange.bind(this);
    }

    /**
     * listener for mobile number change we use this to validate if the mobile number is valid as per the country policy
     * @param status
     * @param value
     * @param countryData
     * @param number
     * @param id
     */
    mobileNumberChange = (status, value, countryData, number, id) => {

        vuePayLog("register.js", "mobileNumberChange", { status, value, countryData, number, id });
        //this is to avoid memory leaks which happens when component is unmounted but still this function gets called from render
        if (this.state.componentMounted) {
            if (status) {
                this.setState({
                    country_code: "+" + countryData.dialCode,
                    mobile_number: value,
                    mobile_number_error: false,
                    mobile_number_valid: true,
                });
            } else {
                this.setState({
                    mobile_number_error: true,
                    mobile_number_valid: false
                });
            }
        }
    };

    componentDidMount() {
        document.getElementsByClassName("modal-overlay")[0].style.display = "block";
        this.setState({
            componentMounted: true
        })
    }

    componentWillMount() {
        this.setState({
            componentMounted: false
        })
        // redirectIfSessionExist((is_session_valid) => {
        //     if(is_session_valid){
        //         this.props.history.push("/dashboard");
        //     }
        // });
    }

    componentWillReceiveProps(nextProps) {
        if (checkIfTwoFactorAuth(nextProps)) {
            if (nextProps.account_management.twoFactorAuth.status_code === 201 || nextProps.account_management.twoFactorAuth.status_code === 200) {
                const { country_code, mobile_number } = this.state

                vuepayAlert("success", nextProps.account_management.twoFactorAuth.message, () => {

                    nextProps.history.push("/verify-otp", { 
                        phone_number_validated: nextProps.location.state.phone_number_validated, 
                        country_code: country_code, mobile_number: mobile_number, 
                        api_token: nextProps.location.state.api_token, 
                        token: nextProps.location.state.token, 
                        userData: nextProps.location.state.userData, 
                        isGolive: nextProps.location.state.isGolive,
                        parentPath: {
                            basePath: nextProps.location.state.parentPath ? nextProps.location.state.parentPath.basePath : nextProps.location.state.basePath,
                            search: nextProps.location.state.parentPath ? nextProps.location.state.parentPath.search : nextProps.location.state.search,
                        } 
                    });
                    nextProps.resetTwoFactorAuth();
                });
            } else {
                vuepayAlert("error", nextProps.account_management.twoFactorAuth.message, () => {
                    nextProps.resetTwoFactorAuth();
                });
            }
        }
    }

    onSubmit(values) {

        vuePayLog(__filename, "onSubmit :: values", values);
        if (this.state.mobile_number_valid) {
            const formData = new FormData();
            formData.append("country_code", this.state.country_code);
            formData.append("mobile_number", this.state.mobile_number);
            formData.append("device[platform]", this.props.device.platform);
            formData.append("device[name]", this.props.device.name);
            formData.append("device[version]", this.props.device.version);
            formData.append("device[ip]", this.props.device.ip);
            formData.append("device[id]", this.props.device.id);
            formData.append("device[app_version]", this.props.device.app_version);
            formData.append("device[device_token]", this.props.device.device_token);

            this.props.towFactorAuth(formData, this.props.location.state.token, this.props.location.state.api_token);
        } else {
            //update the state that the mobile number is not valid and we couldn't submit the form
            this.setState({
                mobile_number_error: true,
            });
        }
    }

    render() {


        const { confirmPasswordError } = this.state

        const { handleSubmit, location } = this.props;
        const basePath = _get(location, 'state.basePath', '')



        return (
            <div>
                <main role="main" className="">
                    <div className="login-container">
                        <div className="popup-header">
                            <button type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                    document.getElementsByClassName("modal-overlay")[0].style.display = "none";
                                    // this.props.history.push(basePath)
                                    this.props.history.push(
                                        {
                                            pathname: this.props.location.state.parentPath ? this.props.location.state.parentPath.basePath : this.props.location.state.basePath,
                                            search: this.props.location.state.parentPath ? this.props.location.state.parentPath.search : this.props.location.state.search,
                                            state: {
                                                basePath: this.props.location.state.parentPath ? this.props.location.state.parentPath.basePath : this.props.location.state.basePath,
                                                search: this.props.location.state.parentPath ? this.props.location.state.parentPath.search : this.props.location.state.search,
                                            }
                                        }
                                    );
                                }
                                }
                            >
                                <img alt={"close-icon"} src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"} />
                            </button>

                        </div>
                        <div className="row" style={{ position: "relative" }}>
                            <div className="col-md-6 bg-primary d-flex align-items-center text-center" style={{ borderRight: '1px solid #e7e7e7' }}>
                                <img src={vuepay_large_logo} alt={"VuePay"} className="img-fluid" />
                            </div>
                            <div className="col-md-6 bg-white d-flex align-items-center">
                                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                    <h4>Enter your mobile number to setup two factor authentication</h4>
                                    <div className="form-group">
                                        <label>Mobile number</label>
                                        <div className="input-group" style={{ height: 47 }}>
                                            <IntlTelInput
                                                onPhoneNumberChange={this.mobileNumberChange}
                                                onPhoneNumberBlur={this.mobileNumberChange}
                                                preferredCountries={['gb']}
                                                css={['intl-tel-input', 'form-control form-control-tel']}
                                                utilsScript={'libphonenumber.js'}
                                            />
                                        </div>
                                        {
                                            this.state.mobile_number_error &&
                                            <p className="text-danger">Please enter valid mobile number.</p>
                                        }
                                    </div>
                                    <div className="mt-4 text-center">
                                        <button className="btn btn-primary">
                                            {
                                                this.props.account_management.isFetching
                                                    ?
                                                    <img src={loading_white} alt={"Loading"} width={26} height={26} />
                                                    :
                                                    'Send OTP'
                                            }
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {

    return {
        account_management: state.account_management,
        device: state.device.payload,
        formData: _get(state, 'form.VerifyMobileForm.values', null),
        initialValues: {
            country_code: '+44',
            mobile_number: '',
        }
    };
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
VerfiyMobileNumber = reduxForm({
    form: 'VerifyMobileForm', // a unique identifier for this form
    enableReinitialize: true,
})(VerfiyMobileNumber)

// You have to connect() to any reducers that you wish to connect to yourself
VerfiyMobileNumber = connect(
    mapStateToProps, // pull initial values from account reducer
    actions // bind account loading action creator
)(VerfiyMobileNumber)

export default VerfiyMobileNumber